import { useQuery } from "@tanstack/react-query";
import { CART_QUERY_KEY } from "@/features/cart/constants/cart.constants";
import { cartService } from "@/features/cart/services/cart.service";
import type { CartResponse } from "@/features/cart/types/cart.type";

type UseCartOptions = { enabled?: boolean };

export const useCart = (options?: UseCartOptions) => {
  return useQuery<CartResponse>({
    queryKey: CART_QUERY_KEY,
    queryFn: cartService.getCart,
    enabled: options?.enabled ?? true,
    refetchOnWindowFocus: true,
    staleTime: 30000,
  });
};
